import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDepthSounder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 76,
	height: 84,
	viewBox: "0 0 76 84",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8105 5.79812C14.5985 4.61412 14.3255 2.78412 16.0955 1.01412C16.9945 0.11512 22.8065 -0.134881 38.2375 0.0641189C57.1775 0.307119 59.2655 0.504118 60.2685 2.14212C61.1555 3.58912 60.9895 4.23812 59.4355 5.39212C57.9015 6.53012 53.4275 6.83312 38.1195 6.83312C26.6765 6.83312 17.9535 6.40912 16.8105 5.79812Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.8765 21.1521C27.8765 20.1931 29.7705 17.4791 32.0845 15.1211C34.3995 12.7631 37.0055 10.8331 37.8765 10.8331C40.0025 10.8331 47.8765 18.9581 47.8765 21.1521C47.8765 23.4521 45.0875 24.4461 42.7445 22.9821C40.9435 21.8581 40.8765 22.5441 40.8765 42.0211V62.2251L44.1745 59.0291C47.7345 55.5781 51.2945 54.8731 52.2735 57.4261C53.0165 59.3611 40.4275 72.8331 37.8765 72.8331C35.3255 72.8331 22.7365 59.3611 23.4795 57.4261C24.4585 54.8731 28.0185 55.5781 31.5785 59.0291L34.8765 62.2251V42.0211C34.8765 22.5441 34.8095 21.8581 33.0085 22.9821C30.6655 24.4461 27.8765 23.4521 27.8765 21.1521Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1225 18.6531C13.6645 19.0021 12.2695 16.8581 13.2655 14.2631C13.6265 13.3211 14.7695 12.8211 16.1225 13.0131C17.7745 13.2481 18.3765 14.0001 18.3765 15.8331C18.3765 17.6661 17.7745 18.4181 16.1225 18.6531Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.1225 18.6531C57.6645 19.0021 56.2695 16.8581 57.2655 14.2631C57.6265 13.3211 58.7695 12.8211 60.1225 13.0131C61.7745 13.2481 62.3765 14.0001 62.3765 15.8331C62.3765 17.6661 61.7745 18.4181 60.1225 18.6531Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8765 28.8331C11.3325 28.8331 10.2255 26.3221 11.8875 24.3201C12.5655 23.5021 13.4615 22.8331 13.8765 22.8331C15.3335 22.8331 17.0945 25.8231 16.5195 27.3201C16.2005 28.1521 15.0115 28.8331 13.8765 28.8331Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.8765 28.8331C59.3325 28.8331 58.2255 26.3221 59.8875 24.3201C60.5655 23.5021 61.4615 22.8331 61.8765 22.8331C63.3335 22.8331 65.0945 25.8231 64.5195 27.3201C64.2005 28.1521 63.0115 28.8331 61.8765 28.8331Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5545 39.2631C8.8825 38.6211 8.2765 35.7661 9.5435 34.5001C10.7895 33.2531 13.9365 33.8271 14.5445 35.4111C15.3475 37.5021 12.6785 40.0781 10.5545 39.2631Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.3765 39.1951C60.8245 38.5991 60.3405 35.7021 61.5855 34.4571C63.0115 33.0321 66.3795 34.3531 66.6795 36.4561C67.0075 38.7531 64.8325 40.1371 62.3765 39.1951Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.8765 49.8331C7.6075 49.8331 6.3405 47.6721 7.2385 45.3331C7.9745 43.4131 10.2785 43.4071 11.8655 45.3201C13.5275 47.3221 12.4205 49.8331 9.8765 49.8331Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.1225 49.6531C63.4015 50.0391 62.1075 47.4651 63.9225 45.2771C65.7965 43.0201 68.3765 43.9291 68.3765 46.8471C68.3765 48.6651 67.7705 49.4191 66.1225 49.6531Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5545 60.2631C4.8825 59.6211 4.2765 56.7661 5.5435 55.5001C6.7895 54.2531 9.9365 54.8271 10.5445 56.4111C11.3475 58.5021 8.6785 61.0781 6.5545 60.2631Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.0625 59.4471C65.2595 58.6451 64.8875 57.2471 65.2355 56.3401C66.1535 53.9481 70.3005 54.7981 70.6795 57.4561C71.0645 60.1541 68.0635 61.4481 66.0625 59.4471Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.7385 70.8331C3.5895 70.8331 2.3605 68.6201 3.2385 66.3331C3.9575 64.4581 6.2665 64.3931 7.7715 66.2061C9.3175 68.0701 8.1035 70.8331 5.7385 70.8331Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.2535 70.6361C67.7125 70.9991 66.3185 68.2111 68.0175 66.1631C69.8105 64.0031 72.3765 64.9941 72.3765 67.8471C72.3765 69.6191 71.7675 70.4201 70.2535 70.6361Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.4475 82.2621C-0.4825 80.3311 -0.4825 80.3351 1.4475 78.4041C2.8165 77.0361 7.5215 76.8331 37.8765 76.8331C68.2315 76.8331 72.9365 77.0361 74.3055 78.4041C76.2355 80.3351 76.2355 80.3311 74.3055 82.2621C72.9365 83.6301 68.2315 83.8331 37.8765 83.8331C7.5215 83.8331 2.8165 83.6301 1.4475 82.2621Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgDepthSounder);
export { ForwardRef as ReactComponent };
